import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Wrapper from 'common/navigation/wrapper';
import MainMenu from 'common/navigation/containers/main-menu-container';
import PlanningBoardContainer from './planning-board-container';

const PlanningBoardRoutes = ({ intl }) =>
  <Wrapper
    title={intl.formatMessage({
      id: 'common.titles.PLANNINGBOARD',
    })}
  >
    <MainMenu type='planningBoard' />
    <PlanningBoardContainer />
  </Wrapper>;
PlanningBoardRoutes.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(PlanningBoardRoutes);
